import { FormGroup } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    checkLabel: {
      marginBottom: -theme.spacing(0.5)
    },
    formLabel: {
      marginBottom: theme.spacing(1)
    },
    root: {
      "& $checkLabel": {
        "&:last-of-type": {
          marginBottom: 0
        }
      },
      padding: 0,
      width: "100%"
    },
    rootNoLabel: {
      marginTop: -theme.spacing(1.5)
    }
  }),
  {
    name: "RadioGroupField"
  }
);

export interface CheckboxGroupFieldChoice<T extends string | number = string> {
  disabled?: boolean;
  id?: string;
  value: T;
  label: React.ReactNode;
}

interface CheckboxGroupFieldProps {
  choices: CheckboxGroupFieldChoice[];
  className?: string;
  disabled?: boolean;
  error?: boolean;
  hint?: string;
  label?: string;
  name?: string;
  value: string[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

export const CheckboxGroupField: React.FC<CheckboxGroupFieldProps> = props => {
  const {
    className,
    disabled,
    error,
    label,
    choices,
    value,
    onChange,
    name,
    hint
  } = props;
  const classes = useStyles(props);

  return (
    <FormControl
      className={classNames(classes.root, className, {
        [classes.rootNoLabel]: !label
      })}
      error={error}
      disabled={disabled}
    >
      {label ? (
        <FormLabel className={classes.formLabel}>{label}</FormLabel>
      ) : null}
      <FormGroup
        aria-label={name}
        // value={value}
        onChange={onChange}
      >
        {choices.length > 0 ? (
          choices.map(choice => (
            <FormControlLabel
              id={choice.id ? `${choice.id}` : null}
              disabled={choice.disabled}
              value={choice.value}
              className={classes.checkLabel}
              control={<Checkbox color="primary" />}
              label={choice.label}
              key={choice.value}
              name={choice.value}
              checked={value.some(item => item === choice.value)}
            />
          ))
        ) : (
          <MenuItem disabled={true}>
            <FormattedMessage defaultMessage="No results found" />
          </MenuItem>
        )}
      </FormGroup>
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </FormControl>
  );
};
CheckboxGroupField.displayName = "CheckboxGroupField";
export default CheckboxGroupField;
